import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { BackEndService } from 'src/app/services/backEnd.service';
import { ToastService } from 'src/app/util/toast.service';
import { LoaderService } from 'src/app/util/loader.service';

@Component({
  selector: 'app-migrate-community',
  templateUrl: './migrate-community.component.html',
  styleUrls: ['./migrate-community.component.scss'],
})
export class MigrateCommunityComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  inviteLink: string = '';

  constructor(
    private auth: AuthService,
    private backEnd: BackEndService,
    private toast: ToastService,
    private loader: LoaderService
  ) { }

  ngOnInit() { }

  async joinCommunity() {
    if (!this.inviteLink) {
      this.toast.error('Please paste an invite link');
      return;
    }

    if (!this.auth.loggedInEmployee) {
      this.toast.error('You must be logged in');
      return;
    }

    try {
      this.loader.show('Migrating your community...');
      let inviteId = this.inviteLink.trim();
      if (inviteId.includes('/')) {
        const parts = inviteId.split('/');
        inviteId = parts[parts.length - 1];
      }
      const payload = {
        invite_id: inviteId,
        emp_id: this.auth.loggedInEmployee.id
      };

      const response = await this.backEnd.post('/api/vanshavali/invite/migrate', payload);

      if (response && response.success) {
        this.toast.success(response.message || 'Successfully migrated community');
        this.inviteLink = '';
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (error: any) {
      console.error('Migration error', error);
    } finally {
      this.loader.hideForce();
    }
  }
}
